import React, { lazy, Suspense, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '../LoadingIndicator';
import retry from '../utils/webpack/chunkRetry';
const VideoPlayerLazy = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "playable" */ 'react-playable')));
export const VideoPlayer = ({ width, height, src, className, autoPlay, loadingCover, fillAllSpace, onInit })=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        setMounted(true);
    }, []);
    const onPlayerInit = (player)=>{
        // Disable picture in picture feature control.
        // Fullscreen affects devpage's own fullscreen so it's disabled as well.
        player.hidePictureInPictureControl();
        player.hideFullScreenControl();
        onInit && onInit(player);
    };
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "VideoPlayer"
    }, mounted && /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            coverMode: true
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(VideoPlayerLazy, {
        src: src,
        autoplay: autoPlay,
        fillAllSpace: fillAllSpace,
        poster: loadingCover,
        onInit: onPlayerInit,
        width: width,
        height: height
    }))), /*#__PURE__*/ React.createElement("noscript", null, /*#__PURE__*/ React.createElement("video", {
        width: width || 640,
        height: height || 480,
        controls: true,
        src: src
    })));
};
VideoPlayer.displayName = 'VideoPlayer';
